import { ColorMode, useColorMode } from '../../contexts/ColorModeContext'
import Icon, { IconName } from '../Common/Icon'
import IconButton from '../Common/IconButton'
import styles from './ColorModeToggle.module.scss'

// Clicking cycles through these in order; the label tells the user what the
// next click switches to.
const NEXT_MODE: Record<ColorMode, ColorMode> = {
  system: 'light',
  light: 'dark',
  dark: 'system',
}

const MODE_LABEL: Record<ColorMode, string> = {
  system: 'system',
  light: 'light',
  dark: 'dark',
}

// The half-filled disc is the "follow the OS" mark: neither day nor night.
const MODE_ICON: Record<ColorMode, IconName> = {
  system: 'contrast',
  light: 'sun',
  dark: 'moon',
}

const ColorModeToggle = () => {
  const { mode, toggleColorMode } = useColorMode()
  const label = `Theme: ${MODE_LABEL[mode]} — switch to ${MODE_LABEL[NEXT_MODE[mode]]}`

  return (
    <IconButton
      title={label}
      tooltipArrow
      className={styles.toggle}
      onClick={toggleColorMode}
      data-cy="color-mode-toggle"
      size="small"
    >
      <Icon name={MODE_ICON[mode]} size="md" />
    </IconButton>
  )
}

export default ColorModeToggle
